module.exports = __webpack_public_path__ + "static/media/Table_Games_Purple@3x.ebd42a61.png";